export class AuthTestDataProvider {
    startTest(data) {
        return axios.post('/tests/attempt', data);
    }

    answer(data) {
        return axios.post('/tests/attempt/answer', data);
    }

    finish(data) {
        return axios.post('/tests/attempt/finish', data);
    }

    getTestResult(data) {
        return axios.post('/tests/attempt/result', data);
    }

    getTestPass(data) {
        return axios.get(`/tests/pass/${data.testId}`);
    }

    getTestAttempt(data) {
        return axios.get(`/tests/attempt/${data.attemptId}`);
    }
}
